import { type ReactNode, useEffect, useRef } from "react";
import { reportUserFacingErrorScreen, type UserFacingErrorScreenReport } from "../lib/sentry/reportUserFacingErrorScreen";
type Episode = {
  screen: UserFacingErrorScreenReport["screen"];
  source: UserFacingErrorScreenReport["source"];
  attempt: number;
};
const isSameEpisode = (left: Episode, right: Episode): boolean => left.screen === right.screen && left.source === right.source && left.attempt === right.attempt;

// StrictMode replays effects while preserving refs, so the same-mount guard
// suppresses the replay.
export function ReportUserFacingErrorScreen({
  screen,
  source,
  error,
  attempt = 0,
  children
}: UserFacingErrorScreenReport & {
  children: ReactNode;
}) {
  const reportedEpisode = useRef<Episode | undefined>(undefined);
  useEffect(() => {
    const episode = {
      screen,
      source,
      attempt
    };
    if (reportedEpisode.current && isSameEpisode(reportedEpisode.current, episode)) {
      return;
    }
    reportedEpisode.current = episode;
    reportUserFacingErrorScreen({
      screen,
      source,
      error
    });
  }, [screen, source, attempt, error]);
  return children;
}